import type { AgentTemplateLocale, LocalizedText } from "./types"

export const resolveAgentTemplateLocale = (
  locale: string | undefined
): AgentTemplateLocale => {
  if (locale?.toLowerCase().startsWith("zh")) return "zh-TW"
  if (locale?.toLowerCase().startsWith("ja")) return "ja"
  return "en"
}

export const resolveLocalizedText = (
  value: LocalizedText,
  locale: AgentTemplateLocale
): string => value[locale]
